import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../services/api";
import toast from "react-hot-toast";

function AddPartner() {

    const navigate = useNavigate();

    const [form, setForm] = useState({
        name: "",
        phone: "",
        email: "",
        status: "active"
    });

    const submit = async (e) => {

        e.preventDefault();

        try {

            await API.post(
                "/admin/partner",
                form
            );

            toast.success(
                "Partner Added Successfully"
            );

            navigate(
                "/admin/partners"
            );

        } catch (err) {

            console.log(err);

            toast.error(
                err.response?.data?.message ||
                "Failed to add partner"
            );

        }

    };

    return (

        <div>

            <h1
                className="
                text-4xl
                font-bold
                mb-6
                "
            >
                Add Partner
            </h1>

            <form
                onSubmit={submit}
                className="
                bg-[#111]
                rounded-2xl
                p-6
                max-w-4xl
                "
            >

                <div
                    className="
                    grid
                    md:grid-cols-2
                    gap-5
                    "
                >

                    <div>

                        <label
                            className="
                            block
                            mb-2
                            font-semibold
                            "
                        >
                            Full Name
                        </label>

                        <input
                            type="text"
                            required
                            value={form.name}
                            onChange={(e) =>
                                setForm({
                                    ...form,
                                    name: e.target.value
                                })
                            }
                            className="
                            w-full
                            p-3
                            rounded-xl
                            bg-black
                            border
                            border-yellow-500/20
                            "
                            placeholder="John Doe"
                        />

                    </div>

                    <div>

                        <label
                            className="
                            block
                            mb-2
                            font-semibold
                            "
                        >
                            Phone
                        </label>

                        <input
                            type="text"
                            required
                            value={form.phone}
                            onChange={(e) =>
                                setForm({
                                    ...form,
                                    phone: e.target.value
                                })
                            }
                            className="
                            w-full
                            p-3
                            rounded-xl
                            bg-black
                            border
                            border-yellow-500/20
                            "
                            placeholder="9876543210"
                        />

                    </div>

                    <div>

                        <label
                            className="
                            block
                            mb-2
                            font-semibold
                            "
                        >
                            Email
                        </label>

                        <input
                            type="email"
                            required
                            value={form.email}
                            onChange={(e) =>
                                setForm({
                                    ...form,
                                    email: e.target.value
                                })
                            }
                            className="
                            w-full
                            p-3
                            rounded-xl
                            bg-black
                            border
                            border-yellow-500/20
                            "
                            placeholder="partner@email.com"
                        />

                    </div>

                    <div>

                        <label
                            className="
                            block
                            mb-2
                            font-semibold
                            "
                        >
                            Status
                        </label>

                        <select
                            value={form.status}
                            onChange={(e) =>
                                setForm({
                                    ...form,
                                    status: e.target.value
                                })
                            }
                            className="
                            w-full
                            p-3
                            rounded-xl
                            bg-black
                            border
                            border-yellow-500/20
                            "
                        >
                            <option value="active">
                                Active
                            </option>

                            <option value="inactive">
                                Inactive
                            </option>

                        </select>

                    </div>

                </div>

                <div
                    className="
                    flex
                    gap-3
                    mt-8
                    "
                >

                    <button
                        type="submit"
                        className="
                        bg-yellow-500
                        text-black
                        px-8
                        py-3
                        rounded-xl
                        font-semibold
                        "
                    >
                        Save Partner
                    </button>

                    <button
                        type="button"
                        onClick={() =>
                            navigate(
                                "/admin/partners"
                            )
                        }
                        className="
                        bg-gray-700
                        px-8
                        py-3
                        rounded-xl
                        "
                    >
                        Cancel
                    </button>

                </div>

            </form>

        </div>

    );

}

export default AddPartner;